import { AnimatePresence, domMax, m } from 'framer-motion';
import { useState } from 'react';
import { useLocation } from 'react-router';

import SocialIcon from '~/assets/icons/Social';
import VectorIcon from '~/assets/icons/Vector';
import { Button } from '~/components/Button';
import FramerMotion from '~/components/FramerMotion';
import ShareToFacebook from '~/components/Social/ShareToFacebook';
import ShareToTwitter from '~/components/Social/ShareToTwitter';
import useEnv from '~/hooks/useEnv';

function ShareIcons() {
  const location = useLocation();
  const env = useEnv();

  const url = `${env.SITE_BASE_URL}${location.pathname}`;

  const [shareButtonsVisible, setShareButtonsVisible] = useState(false);

  return (
    <FramerMotion feature={domMax}>
      <m.div
        layout="position"
        className="flex max-h-5 min-w-fit flex-row items-center justify-end gap-2 pt-3"
      >
        <AnimatePresence>
          <m.div className="flex w-6">
            <Button
              aria-label="share"
              variant="none"
              onClick={() => {
                setShareButtonsVisible(!shareButtonsVisible);
              }}
              className="flex items-center justify-center bg-transparent p-1"
            >
              {!shareButtonsVisible ? (
                <SocialIcon height="16" width="16" />
              ) : (
                <VectorIcon width="12" height="12" />
              )}
            </Button>
          </m.div>
          <m.div
            className={`flex gap-2 ${
              shareButtonsVisible ? 'visible' : 'hidden'
            }`}
            animate={shareButtonsVisible ? 'open' : 'closed'}
            variants={{
              closed: { opacity: 0, x: 40 },
              open: { opacity: 1, x: 0 }
            }}
          >
            <ShareToFacebook position={1} url={url} />
            <ShareToTwitter
              position={2}
              text={`Check out this new article from @thesolesupplier: ${url}`}
            />
          </m.div>
        </AnimatePresence>
      </m.div>
    </FramerMotion>
  );
}
export default ShareIcons;
